"use client";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LazyImportPlugin from "~i18n/lazy-load-plug-in-i18n";

void i18n
  .use(initReactI18next)
  .use(LazyImportPlugin)
  .init({
    lng: "th",
    fallbackLng: "th",
    supportedLngs: ["th", "en", "vi", "cn"],
    debug: false,
    load: "languageOnly",
    preload: [],
    ns: ["errors"],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
